import HttpService from './baseHttp'

//Download测算
export const HttpSkuPublish = (data = {}) => HttpService.post("/api/v2/product/itemPublish", data, { headers: { "Content-Type": "application/json" },baseURL: process.env.VUE_APP_APIURL_FBB });
//包裹运费测算
export const HttpGetSku = (data = {}) => HttpService.post("/api/v2/product/getSkuInfo", data, { headers: {  }, baseURL: process.env.VUE_APP_APIURL_FBB });


// 客户报价列表、查看、新增、编辑、删除、

export const HttpGetCustomerPriceList = (data = {}, config) => HttpService.get('/api/v2/quotation/head/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpGetCustomerPriceOneOrg = (data = {}, config) => HttpService.get('/api/v2/quotation/head/findById', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
export const HttpGetCustomerPriceTable = (data = {}, config) => HttpService.get('/api/v2/quotation/item/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
export const HttpGetCustomerPriceOneDetail = (data = {}, config) => HttpService.get('/api/v2/quotation/item/findById', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpSaveCustomerPriceOneOrg = (data = {}) => HttpService.post("/api/v2/quotation/head/save", data, { headers: { "Content-Type": "application/json" },baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpSaveCustomerPriceOneDetail = (data = {}) => HttpService.post("/api/v2/quotation/item/save", data, { headers: { "Content-Type": "application/json" },baseURL: process.env.VUE_APP_APIURL_FBB });

export const DeleteCustomerPriceOneDetail = (data = {}, config) => HttpService.get('/api/v2/quotation/item/delete', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
